import React from "react";
import FInputt from "../FInputt/FInputt";
import { useNavigate } from "react-router";
import VectorIcons from "../VectorIcons/VectorIcons";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
export const AlertModalKyc = ({ type = "PENDING", onChange: onChange }) => {
  const MySwal = withReactContent(Swal);

  return (
    <div className="p-2">
      <div className="flex justify-center p-5">
        {type == "PENDING" ? (
          <img
            src={require("../../components/assets/images/kyc.png")}
            alt=""
          />
        ) : null}
        {type == "IN_PROCESS" ? (
          <img
            src={require("../../components/assets/images/Work.png")}
            alt=""
          />
        ) : null}
        {type == "REJECTED" ? (
          <img
            src={require("../../components/assets/images/Work.png")}
            alt=""
          />
        ) : null}
      </div>
      <div className="text-2xl font-bold text-center pb-3">
        Validación de identidad
      </div>
      <div className="text-lg text-center pb-3">
        {type == "PENDING" ? "Necesitamos validar tu información" : null}
        {type == "IN_PROCESS" ? "Tus documentos se encuentran en proceso de verificación" : null}
        {type == "REJECTED" ? "Tus documentos no fueron aprobados, te invitamos a iniciar el proceso nuevamente" : null}
      </div>
      <FInputt
        type="botton"
        title={"Ok"}
        onChange={onChange}
      />
    </div>
  );
};
